import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from '@/util/SBAPI';
import SBArtistListCategoryIcon from './SBArtistListCategoryIcon.vue';


@Component({
    components: {
        SBArtistListCategoryIcon,
    }
})
export default class SBImg extends Mixins(SBComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    img!: string;

    @Prop({
        type: String,
        default: "",
    })
    public href!: string;

    @Prop({
        type: String,
        default: "",
    })
    public to!: string;
}
